import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  goTo(route) {
    this.props.history.replace(`/${route}`);
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }


  render() {
    const { isAuthenticated } = this.props.auth;

    return (
      <div className="AppContainer">
        <header className="header">
          <div className="container">
            <nav className="inner">
              <div className="left">
                <span>NetWorthly</span>
                {/* <a href="/" class="selected">Dashboard</a> */}
              </div>
              <div className="right">
                <div className="loginLogoutButtons">
                  {
                    !isAuthenticated() && (
                      <a
                        className="btn btn-secondary"
                        onClick={this.login.bind(this)}
                      >
                        Log In
                  </a>
                    )
                  }
                  {
                    isAuthenticated() && (
                      <a
                        className="btn btn-secondary"
                        onClick={this.logout.bind(this)}
                      >
                        Log Out
                  </a>
                    )
                  }
                </div>
              </div>
            </nav>
          </div>
        </header>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js